import { ERROR_PREFIXES } from 'src/common/constants';
import * as FetchService from '../fetch/FetchService.client';

export type DisclaimerFromSettings = {
    disclaimerID: string;
    paramName?: string;
    paramValue?: string | boolean;
};
export type DisclaimerFromSettingsWithParamName = {
    disclaimerID: string;
    paramName: string;
    paramValue?: string | boolean;
};
export type SettingsResponse = {
    value: DisclaimerFromSettings[];
};
export const getPublicSettingsValues = async (key: string): Promise<DisclaimerFromSettings[]> => {
    const clientManager = FetchService.RESTServiceClientManagerFactory.getServiceClientManager();
    const settingsService = clientManager.settings;
    const response = await settingsService.GET<SettingsResponse>({ action: `v1/public/values/${key}` });
    if (
        response.type === FetchService.Domain.ResponseType.NETWORK_ERROR ||
        settingsService.isBadStatus(response.statusCode)
    ) {
        const error = new Error(
            `${
                ERROR_PREFIXES.PUBLIC_SETTINGS_API
            } Failed to retrieve disclaimers from settings service for ${key}. Status Code ${
                response.type !== FetchService.Domain.ResponseType.NETWORK_ERROR ? response.statusCode : null
            }`
        );
        throw error;
    }
    const { value } = response.data;
    return value;
};
